export const CLOSE_BUTTON_OFFSET = {
  base: 4,
  md: 8,
};
